// src/features/help/components/HelpDrawer.tsx

import { Suspense, lazy } from 'react';
import { Center, Drawer, Loader } from '@mantine/core';

// The body (and the whole content corpus behind it) loads as a separate
// chunk on first open — the drawer shell is all that rides in the main
// bundle (plan §5.2).
const HelpDrawerBody = lazy(() =>
  import('./HelpDrawerBody').then((m) => ({ default: m.HelpDrawerBody })),
);

interface HelpDrawerProps {
  opened: boolean;
  onClose: () => void;
}

export function HelpDrawer({ opened, onClose }: HelpDrawerProps) {
  return (
    <Drawer opened={opened} onClose={onClose} position="right" size={400} title="Help" padding="md">
      {opened && (
        <Suspense
          fallback={
            <Center h={120}>
              <Loader size="sm" />
            </Center>
          }
        >
          <HelpDrawerBody onClose={onClose} />
        </Suspense>
      )}
    </Drawer>
  );
}
